import { render, staticRenderFns } from "./settings-categories.vue?vue&type=template&id=4dc8dd37&"
import script from "./settings-categories.vue?vue&type=script&lang=js&"
export * from "./settings-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "settings-categories.vue"
export default component.exports